import * as actionTypes from "../actionTypes.js";

const initialState = {
  campaignsList: null,
};

const businessFusionWyziaReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_CAMPAIGNS_BIZ_FUSION_WYZIA:
      return { ...state, campaignsList: action.payload };
      

    case actionTypes.LOG_OUT:
      return initialState;

    default:
      return state;
  }
};

export default businessFusionWyziaReducer;